import axios from "axios";
import { AUTH_TOKEN, AUTH_USER } from "../redux/constants/Auth";

export const $api = axios.create();

// Request interceptor
$api.interceptors.request.use((config) => {
  const reactJSId = sessionStorage.getItem("reactJSId");
  config.headers = {
    ...config.headers,
    "React-App-Id": reactJSId || "_",
  };
  return config;
});

// Response interceptor
$api.interceptors.response.use(
  function (response) {
    try {
      if (response.data.slice(0, 15) === "<!doctype html>") {
        localStorage.removeItem(AUTH_TOKEN);
        localStorage.removeItem(AUTH_USER);
        window.location.reload();
      } else {
        return response;
      }
    } catch (e) {
      return response;
    }
  },
  function (error) {
    try {
      if (error.config.url === "/api/login") {
        return error;
      }
    } catch (e) {
      console.error("Login error", e);
    }
    if (error.response === undefined) {
      localStorage.removeItem(AUTH_TOKEN);
      localStorage.removeItem(AUTH_USER);
      window.location.reload();
    } else {
      return error;
    }
  }
);
